<template>
  <v-container id="login" class="fill-height" tag="section">
    <v-row justify="center">
      <v-form @submit.prevent="login()">
        <v-slide-y-transition appear>
          <base-material-card
            color="#ca1439"
            light
            max-width="100%"
            width="400"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  {{ $t("Login") }}
                </h1>
              </div>
            </template>

            <v-card-text class="text-center">
              <v-text-field
                color="secondary"
                label="Email..."
                name="email"
                prepend-icon="mdi-email"
                v-model="email"
                data-vv-name="email"
                :error-messages="errors.collect('email')"
              />

              <v-text-field
                class="mb-8"
                color="secondary"
                type="password"
                label="Password..."
                name="password"
                prepend-icon="mdi-lock-outline"
                v-model="password"
                data-vv-name="password"
                :error-messages="errors.collect('password')"
              >
                <template v-slot:append>
                  <a @click="$router.push({ name: 'auth.forgot' })">{{
                    $t("Forgot?")
                  }}</a>
                </template>
              </v-text-field>

              <pages-btn
                color=""
                depressed
                type="submit"
                class="v-btn--text text--darken-2 text--red"
              >
                {{ $t("Login") }}
              </pages-btn>
            </v-card-text>
          </base-material-card>
        </v-slide-y-transition>
      </v-form>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "login",
  components: {
    PagesBtn: () =>
      import("@/app/shared/components/template/pages/components/Btn")
  },
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      email: null,
      password: null,
      has_error: false
    };
  },
  methods: {
    login() {
      // get the redirect object
      // var redirect = this.$auth.redirect();
      var app = this;
      this.$auth.login({
        params: {
          email: app.email,
          password: app.password
        },
        success: function() {
          // handle redirection
          //TODO: Set correct routes
          // const redirectTo = redirect
          //   ? redirect.from.name
          //   : this.$auth.user().role === 2
          //   ? "admin.dashboard"
          //   : "dashboard";
          this.$router.push({ name: "dashboard.index" });
        },
        error: function(error) {
          for (let field in error.response.data.errors) {
            this.$validator.errors.add({
              field: field,
              msg: error.response.data.errors[field][0]
            });
          }
          app.has_error = true;
        },
        rememberMe: true,
        fetchUser: true
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
